import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetcher = (url) => api.get(url).then((r) => r.data);

export const photoUrl = (id) => `${API}/photos/${id}/file`;
export const docUrl = (id, download = false) => `${API}/documents/${id}/view${download ? "?download=true" : ""}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
